
import { AssetMaintenanceTypeInfoBase } from './asset-maintenance.typeinfo.base';


export class AssetMaintenanceTypeInfo extends AssetMaintenanceTypeInfoBase {
}

export const ASSET_MAINTENANCE_TYPE: AssetMaintenanceTypeInfo = new AssetMaintenanceTypeInfo();



